import React from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import przepisy from '../../assets/przepisy.jpg';
import encyklopedia from '../../assets/encyklopedia.jpg';

const Root = styled('div')(({ theme }) => ({
  padding: theme.spacing(4, 0),
  textAlign: 'left',
}));

const SectionTitle = styled(Typography)({
  textAlign: 'center',
  marginBottom: '40px',
});

const FeaturesContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '16px',
  justifyContent: 'center',
  textAlign: 'center',
}));

const FeatureItemContainer = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 calc(33.33% - 16px)',
  [theme.breakpoints.down('sm')]: {
    flex: '1 1 100%',
  },
}));

const FeatureContent = styled('div')(({ theme }) => ({
   height: '100%',
    display: 'flex',
    flexDirection: 'column',
  justifyContent: 'flex-start',
  padding: theme.spacing(2),
  backgroundColor: '#FFFFFF',
  borderRadius: theme.spacing(2),
  border: '1px solid #E0E0E0',
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
  flexGrow: 1,
}));

const FeatureTitle = styled(Typography)(({ theme }) => ({
  color: '#4F4F4F',
  fontWeight: 'bold',
  marginBottom: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
}));

const FeatureDescription = styled(Typography)(({ theme }) => ({
  color: '#4F4F4F',
    flex: 1,
  textAlign: 'justify',
  padding: theme.spacing(2, 1),
}));

const FeatureImageWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  maxWidth: '300px',
  margin: '0 auto',
}));

const FeatureImage = styled('img')(({ theme }) => ({
  width: '100%',
  height: 'auto',
  borderRadius: '8px',
}));

const Features = () => {
  return (
    <Root>
      <Container>
        <SectionTitle variant="h3" gutterBottom>
          Funkcje aplikacji
        </SectionTitle>
        <FeaturesContainer maxWidth="xl">
          <Grid container spacing={2} alignItems="stretch">
            <FeatureItemContainer item xs={12} md={6}>
              <FeatureContent>
                <FeatureTitle variant="h5" gutterBottom>
                  <AutoStoriesIcon />
                  Encyklopedia produktów
                </FeatureTitle>
                <FeatureDescription variant="body2">
                  Encyklopedia produktów spożywczych z informacjami o składnikach odżywczych i alergenach. Pomoże Ci w wyborze odpowiedniego jedzenia dla dziecka.
                </FeatureDescription>
                 <FeatureImageWrapper>
                              <FeatureImage src={encyklopedia} alt="Encyklopedia" />
                            </FeatureImageWrapper>
              </FeatureContent>
            </FeatureItemContainer>

            <FeatureItemContainer item xs={12} md={6}>
              <FeatureContent>
                <FeatureTitle variant="h5" gutterBottom>
                  <MenuBookIcon />
                  Przepisy
                </FeatureTitle>
                <FeatureDescription variant="body2">
                  Znajdziesz tu przepisy dostosowane do różnych etapów rozwoju dziecka. Wszystkie są proste w przygotowaniu, zdrowe i smaczne.
                </FeatureDescription>
                  <FeatureImageWrapper>
                                                            <FeatureImage src={przepisy} alt="Przepisy" />
                                                          </FeatureImageWrapper>
              </FeatureContent>
            </FeatureItemContainer>
          </Grid>
        </FeaturesContainer>
      </Container>
    </Root>
  );
};

export default Features;
